import { FREE_TEXT_ID, type QuestionDef } from "@/components/hitl/user-choice/useUserChoice";

export interface AnswerResult {
	selected_ids?: string[];
	free_text?: string | null;
	skipped?: boolean;
}

/** tool_result の出力 (JSON) を質問数ぶんの回答へ展開する。未回答・解析不能なら null 埋め。 */
export function parseAnswers(output: string | undefined, count: number): (AnswerResult | null)[] {
	const empty = Array.from({ length: count }, () => null);
	if (!output) return empty;
	let parsed: unknown;
	try {
		parsed = JSON.parse(output);
	} catch {
		return empty;
	}
	if (parsed && typeof parsed === "object") {
		const answers = (parsed as { answers?: unknown }).answers;
		if (Array.isArray(answers)) {
			return Array.from({ length: count }, (_, i) => (answers[i] as AnswerResult) ?? null);
		}
		// 単一質問: 結果オブジェクトがそのまま回答。
		return Array.from({ length: count }, (_, i) => (i === 0 ? (parsed as AnswerResult) : null));
	}
	return empty;
}

/** 1 質問ぶんの回答を表示用ラベルへ変換する。選択肢 id はラベルへ解決する。 */
export function answerLabel(question: QuestionDef, answer: AnswerResult | null): string {
	if (!answer) return "回答待ち";
	const ids = answer.selected_ids ?? [];
	if (answer.skipped || (ids.length === 0 && !answer.free_text)) return "スキップ";
	const parts = ids
		.map((id) =>
			id === FREE_TEXT_ID
				? (answer.free_text?.trim() ?? "")
				: (question.choices?.find((c) => c.id === id)?.label ?? id),
		)
		.filter(Boolean);
	return parts.join("、") || "スキップ";
}
